import { NEWS_VIDEOS } from '../utils/constants';

export default {
  computed: {
    newsVideos() {
      return this.$store.getters[NEWS_VIDEOS.GET_VIDEOS];
    }
  },
  methods: {
    async getNewsVideos() {
      await this.$store.dispatch(NEWS_VIDEOS.FETCH_VIDEOS, {
        enterpriseParams: this.getByEnterpriseParams
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/newsVideo.js